import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../components/Modal';
import { useAssignmentContext } from '../../../context';
import { useValidateAssignmentNameMutation } from '../../../../../features/authentication/assignApiSlice';
import CustomToast from '../../../../../components/Toast';
import appConfig from '../../../../../app-config';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from '../../../../../features/authentication/authSlice';
import ConfirmationModal from '../../../../../components/ConfirmationPopUp';
import WarningAlert from './WarningAlert';

const baseUrl = appConfig.apiBaseUrl
const PublishSubmitMenuModal = ({
  title,
  isOpen,
  onClose,
  textboxLabel,
  note,
  submit,
  apiParamOptions,
  helpText,
  confirmationMsg,
  fromMoreActions
}) => {
  const token = useSelector(selectCurrentToken);
  const [validateAssignmentName] = useValidateAssignmentNameMutation();
  const [confirmationAlert, setConfirmationAlert] = useState(false);
  const [warningAlert, setWarningAlert] = useState(false);
  const [validatedAssignmentName, setValidatedAssignmentName] = useState('');
  const [message, setMessage] = useState('');
  const [replace, setReplace] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const { assignmentName, setAssignmentName } = useAssignmentContext();
  const selectedAssignment = useAssignmentContext();

  const handleAssignmentName = (event) => {
    const assignmentName = event.target.value;
    setAssignmentName(assignmentName);
  };

  const validateAssignmentNameAsync = async (assignmentName) => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const options = {
          assignmentId: !fromMoreActions ? selectedAssignment.assignedData[0].assignmentId : selectedAssignment.assignmentId,
          publicAssignmentName: assignmentName,
          options: apiParamOptions
        };
        const validateAssignmentNameResponse = await validateAssignmentName(options).unwrap();
        onClose(false);
        if (!validateAssignmentNameResponse.showAlert) {
          setWarningAlert(false);
          setConfirmationAlert(true); //confirmation modal opens
          setValidatedAssignmentName(assignmentName);
        } else {
          if (validateAssignmentNameResponse.ownedSelf) {
            selectedAssignment.setSaveAs(false);
            selectedAssignment.setNeverShow(true);
          } else {
            selectedAssignment.setSaveAs(true);
          }
          showWarningAlert(validateAssignmentNameResponse.showAlert);
          setReplace(validateAssignmentNameResponse.ownedSelf);
          setMessage(validateAssignmentNameResponse.message);
        }
        if (validateAssignmentNameResponse) {
          setIsLoading(false);
          setIsDisabled(false);
        }
      } catch (ex) {
        selectedAssignment.setSaveAs(false);
        showWarningAlert(ex.data.showAlert);
        setReplace(ex.data.ownedSelf);
        setMessage(ex.data.message);
        setIsLoading(false);
        setIsDisabled(false);
      }
    }
  };

  const replaceAssignmentAsync = async () => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const options = {
          assignmentId: !fromMoreActions ? selectedAssignment.assignedData[0].assignmentId: selectedAssignment.assignmentId,
          publicAssignmentName: selectedAssignment.assignmentName,
          options: apiParamOptions
        };
        let url = baseUrl + '/Assignment/ReplaceAssignment';
        url += '?assignmentId=' + options.assignmentId + '&';
        url += 'publicAssignmentName=' + options.publicAssignmentName + '&';
        url += 'options=' + options.options;
        const headers = {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        };
        const response = await fetch(url, { headers, method: 'POST' });
        const errorMsg = await response.text();
        const result = response.status;
        if (result === 200) {
          CustomToast(
            `The assignment has been successfully saved as a ${
              submit ? 'Benchmark' : 'Public'
            } Assignment named "${selectedAssignment.assignmentName}"`,
            'success'
          );
          setWarningAlert(false);
          selectedAssignment.setAssignedDataStatus(new Date().getSeconds());
          selectedAssignment.setAssignedData([]);
          selectedAssignment.setAssignedName([]);
          selectedAssignment.setAssignmentId('');
          selectedAssignment.setAssignedCourseName([]);
          setIsLoading(false);
        } else {
          CustomToast(`${errorMsg}`, 'info');
          setIsLoading(false);
        }
      } catch (ex) {
        console.log(ex);
      }
    }
  };

  const publishAssignmentAsync = async (assignmentName) => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const options = {
          assignmentId: !fromMoreActions ? selectedAssignment.assignedData[0].assignmentId : selectedAssignment.assignmentId,
          publicAssignmentName: assignmentName,
          options: apiParamOptions
        };
        let url = baseUrl + '/Assignment/PublishAssignment';
        url += '?assignmentId=' + options.assignmentId + '&';
        url += 'publicAssignmentName=' + options.publicAssignmentName + '&';
        url += 'options=' + options.options;
        const headers = {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        };
        const response = await fetch(url, { headers, method: 'POST' });
        const result = response.status;

        if (result === 200) {
          CustomToast(
            `The assignment has been successfully saved as a ${
              submit ? 'Benchmark' : 'Public'
            } Assignment named "${assignmentName}"`,
            'success'
          );
          setConfirmationAlert(false);
          selectedAssignment.setNeverShow(true);
          selectedAssignment.setSaveAs(false);
          setWarningAlert(false);
          onClose(false);
          selectedAssignment.setAssignedDataStatus(new Date().getSeconds());
          selectedAssignment.setAssignedData([]);
          selectedAssignment.setAssignedName([]);
          selectedAssignment.setAssignmentId('');
          selectedAssignment.setAssignedCourseName([]);
        }
        setIsLoading(false);
      } catch (ex) {
        console.log(ex);
        setIsLoading(false);
      }
    }
  };

  const showConfirmation = (confirmMsg) => {
    if (confirmMsg) {
      selectedAssignment.setAssignmentName(validatedAssignmentName);
      publishAssignmentAsync(validatedAssignmentName);
    } else {
      onClose(true);
      setConfirmationAlert(false); //not publish and close cofirmation alert
      selectedAssignment.setNeverShow(true);
      selectedAssignment.setSaveAs(false);
    }
  };

  const showWarningAlert = (alert) => {
    setWarningAlert(alert);
    alert ? onClose(false) : onClose(true);
  };

  useEffect(() => {
    selectedAssignment.assignedName.map((item) => setAssignmentName(item.trim()));
  }, [isOpen]);

  return (
    <>
      <Modal
        contentWidth="1000px"
        isOpen={isOpen}
        titleName={title}
        onClose={() => onClose(false)}
        titleToolTip={helpText}>
        <div className="d-flex align-items-center justify-content-between name-display-box">
          <div className="display-label">
            Your assignment:{' '}
            <span className="display-name">{selectedAssignment.assignedName[0]}</span>
          </div>
          <div className="display-label">
            Course: <span className="display-name">{selectedAssignment.assignedCourseName[0]}</span>
          </div>
        </div>
        <div className="my-4">
          <label className="form-label">{textboxLabel}</label>
          <input
            type="text"
            className="form-control"
            value={assignmentName}
            onChange={(e) => handleAssignmentName(e)}
          />
        </div>
        {submit && <p>{note}</p>}
        <div className="col-12 d-flex justify-content-end mt-5">
          <button className="btn btn-castleGray me-2" onClick={() => onClose(false)}>
            Cancel
          </button>
          <button
            className="btn btn-castleRed"
            onClick={() => validateAssignmentNameAsync(assignmentName)}
            disabled={isDisabled}>
            Publish
          </button>
        </div>
      </Modal>
      <ConfirmationModal
        isOpen={confirmationAlert}
        onClose={() => showConfirmation(false)}
        onSave={() => showConfirmation(true)}
        isLoading={isLoading}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={confirmationMsg}
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
      <WarningAlert
        isOpen={warningAlert}
        onClose={() => showWarningAlert(false)}
        isLoading={isLoading}
        replaceName={replace}
        contentWidth={'40%'}
        content={message}
        setContent={setMessage}
        saveButton={'Save'}
        cancelButton={'Cancel'}
        replaceData={replaceAssignmentAsync}
        validateData={validateAssignmentNameAsync}
      />
    </>
  );
};

PublishSubmitMenuModal.propTypes = {
  title: PropTypes.string.isRequired,
  textboxLabel: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  note: PropTypes.string,
  submit: PropTypes.bool,
  apiParamOptions: PropTypes.number,
  helpText: PropTypes.string,
  confirmationMsg: PropTypes.string,
  fromMoreActions: PropTypes.bool,
};

export default PublishSubmitMenuModal;
